export { default } from './InputSlider';
